import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/car/description',
    name: 'CarDescription',
    meta: {
      title: '功能说明',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/car/description/index.vue'),
  },
  {
    path: '/car/widgetDes',
    name: 'CarWidgetDescription',
    meta: {
      title: '添加小组件说明',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/car/widgetDescription/index.vue'),
  },
  {
    path: '/car/consume',
    name: 'CarConsume',
    meta: {
      title: '养车消费单',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/car/consume/index.vue'),
  },
  {
    path: '/car/chargeDescription',
    name: 'CarChargeDescription',
    meta: {
      title: '充电说明',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/car/chargeDescription/index.vue'),
  },
]

export default routes
